export const RESET_2FA = '@2FA/RESET_2FA'
export const VERIFY_CODE = '@2FA/VERIFY_CODE'
export const GENERATE_CODE = '@2FA/GENERATE_CODE'
export const VERIFY_CODE_RESET = '@2FA/VERIFY_CODE_RESET'
